'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EncodeFilter = EncodeFilter;
function EncodeFilter($window) {
    'ngInject';

    return encode;

    /**
     * URL-encode a string
     *
     * @param {String} input
     * @return {String} output
     */
    function encode(input) {
        return $window.encodeURIComponent(input);
    }
}


/** WEBPACK FOOTER **
 ** ./src/encode.filter.js
 **/